import loadable from '@loadable/component';

export const TheBlendSiteWrapper = loadable(
  () => import(/* webpackChunkName: "theblend-site" */ './TheBlendSiteWrapper'),
);
